import { Injectable } from "@angular/core";
import { IID_OL_ANNULLAMENTO} from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolAnnullatoStore } from "./annullato.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ANNULLATO)
export class IIDolAnnullatoQuery extends AbstractInterfaceDataQuery<IID_OL_ANNULLAMENTO> {

  constructor(protected store: IIDolAnnullatoStore) {
    super(store);
  }
}
